import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-8" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Salary reports"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Overview workers and download salary reports")
], -1)
const _hoisted_4 = { class: "form-check form-switch" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "taxIdCheckbox"
}, "Show taxID workers", -1)
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end w-100 mb-4"
}
const _hoisted_9 = {
  key: 1,
  class: "w-100 w-sm-75 d-flex align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border text-primary spinner-border-sm",
    role: "status"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 text-primary ms-2 me-4" }, "Downloading...", -1)
const _hoisted_12 = { class: "progress w-100" }
const _hoisted_13 = { class: "row mt-3 justify-content-sm-start justify-content-center ms-0 ps-0" }
const _hoisted_14 = { class: "col-12 col-md-6 col-lg-5 ps-0" }
const _hoisted_15 = { class: "col-12 col-md-6 col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayModal = _resolveComponent("PayModal")!
  const _component_MissingReportsModal = _resolveComponent("MissingReportsModal")!
  const _component_MissingRatesModal = _resolveComponent("MissingRatesModal")!
  const _component_ShiftsModal = _resolveComponent("ShiftsModal")!
  const _component_SalaryReportsSummary = _resolveComponent("SalaryReportsSummary")!
  const _component_SearchField = _resolveComponent("SearchField")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_SalaryReportsDataTable = _resolveComponent("SalaryReportsDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createVNode(_component_PayModal, {
      ref: "paySalaryModal",
      onHandleMissingRates: _cache[0] || (_cache[0] = ev => _ctx.handleMissingRates(ev.query, ev.response)),
      onSalaryPaid: _ctx.handleSalaryPaid
    }, null, 8, ["onSalaryPaid"]),
    _createVNode(_component_MissingReportsModal, { shifts: _ctx.missingReportsShifts }, null, 8, ["shifts"]),
    (_openBlock(), _createBlock(_component_MissingRatesModal, {
      missingRates: _ctx.missingRates,
      key: _ctx.modalkey,
      onModalCloseEnd: _ctx.handleMissingRatesModalClose,
      onUseOnce: _ctx.handleUseOnce,
      onSavedRates: _ctx.handleSaveRates
    }, null, 8, ["missingRates", "onModalCloseEnd", "onUseOnce", "onSavedRates"])),
    _createVNode(_component_ShiftsModal, {
      loading: _ctx.getShiftsLoading,
      userShifts: _ctx.getShiftsData.data
    }, null, 8, ["loading", "userShifts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: "taxIdCheckbox",
            unchecked: "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showTaxIdWorkers) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showTaxIdWorkers]
          ]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(), _createBlock(_component_SalaryReportsSummary, {
            key: _ctx.summaryKey,
            date: _ctx.date,
            search: _ctx.search,
            "show-tax-id": _ctx.showTaxIdWorkers
          }, null, 8, ["date", "search", "show-tax-id"])),
          (_ctx.getData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!_ctx.isGeneratingReports)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadAll && _ctx.handleDownloadAll(...args))),
                      class: "fs-5 text-dark cursor-pointer"
                    }, "Download all reports"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: "progress-bar progress-bar-animated progress-bar-striped",
                          role: "progressbar",
                          style: _normalizeStyle(`width: ${_ctx.progressBar}%`),
                          "aria-valuenow": "10",
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        }, null, 4)
                      ])
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_SearchField, {
              placeholder: 'Search users...',
              onChangeSearch: _ctx.changeSearch
            }, null, 8, ["placeholder", "onChangeSearch"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_date_picker, {
              class: "input-class w-100 w-md-75 w-lg-50 mt-3 mt-md-0",
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.date) = $event)),
              clearable: false,
              size: "large",
              type: "daterange",
              "start-placeholder": "From",
              "end-placeholder": "To",
              format: "DD/MM/YYYY",
              "value-format": "DD/MM/YYYY"
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_ctx.getData == '')
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: 
            'OOPS... Unfortunately no results matching your filters were found.'
          
              }, null, 8, ["description"]))
            : (_openBlock(), _createBlock(_component_SalaryReportsDataTable, {
                key: 2,
                tableData: _ctx.getData,
                onOpenPayModal: _ctx.handleOpenPayModal,
                onDownload: _ctx.exportPaySlip,
                onShifts: _ctx.openUserShifts
              }, null, 8, ["tableData", "onOpenPayModal", "onDownload", "onShifts"])),
        _createVNode(_component_Pagination, {
          currentPage: _ctx.pagination.currentPage,
          totalPages: _ctx.pagination.lastPage,
          onChangeCurrentPage: _ctx.changeCurrentPage
        }, null, 8, ["currentPage", "totalPages", "onChangeCurrentPage"])
      ])
    ])
  ], 2))
}